import * as React from 'react';
import { Spinner } from '../uiComponents/Spinner';

export interface LoadingProps {
    isLoading: boolean;
    children: any;
}
export function Loading(props: LoadingProps) {
    if (props.isLoading) {
        return <Spinner />;
    } else {
        return props.children;
    }
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/Loading.tsx